/*global VeloxWebView, VeloxFormController*/

var ControllerWithImage = require("../../util/ControllerWithImage") ;

/**
 * This is a basic MVC grid/form controller
 * 
 * It creates 2 routes : #part/list and #part/form
 */
var partController = new ControllerWithImage("part", {
    grid : {
        directory: "views/part",
        name: "partGrid",
    },
    form : {
        directory: "views/part",
        name: "partForm",
        joinFetch: [
            {otherTable: "link_part_part", thisField:"p_ref", otherField: "part_parent", type:"2many", name: "parts", orderBy:"part_child", joins: [
                {otherTable: "part", thisField: "part_child", otherField: "p_ref", flatten: true}
            ] }
        ]
    }
});


partController.formController.getRecordsToSave = function(viewData, dataBeforeModif, callback){
    if(dataBeforeModif && viewData.p_ref !== dataBeforeModif.p_ref){
        //the code (primary key) has been changed, must use a updateWhere 
        //(cascade on foreign key will update other tables)

        var records = [] ;
        records.push({
            table: "part",
            action: "updateWhere",
            record: {
                values: viewData,
                conditions: {p_ref: dataBeforeModif.p_ref},
            }
        }) ;
        callback(null, records) ;
    }else{
        //the code has not been changed, use normal method
        var records = [] ;
        records.push({
            table: "part",
            record: viewData
        }) ;
        callback(null, records) ;
    }
};



partController.formController.onAddRemoveParts = function(){
    //open popup
    this.view.longTask(function(done){
        this.api.api.multiread({
            part : { search: {}, orderBy: "p_ref" }
        }, done);
    }.bind(this), function(err, reads){
        if(err){ return ;}

        reads.part.forEach(function(p){
            if(p.p_name && p.p_name.length > 25){
                p.p_name = p.p_name.substring(0,25)+"..." ;
            }
        }) ;

        var dataPopup = {
            available: reads.part.filter(function(p){
                return !this.data.parts.some(function(s){ return s.p_ref === p.p_ref ;}) ;
            }.bind(this)),
            selected: this.data.parts
        } ;

        var viewAddRemove = new VeloxWebView("views/part", "popupAddRemove", {bindObject: dataPopup}) ;
        viewAddRemove.openInPopup({
            size:"large",
            title: VeloxWebView.tr("device.addRemoveParts")
        })  ;
    
        /**
         * User validate creation of a new user
         */
        viewAddRemove.on("validate",function(){
            viewAddRemove.updateData() ;
            viewAddRemove.close() ;
            
            var changes = [] ;
            changes.push({table: "link_part_part", action: "removeWhere", record:{part_parent : this.data.p_ref}}) ;
            dataPopup.selected.forEach(function(p){
                changes.push({table: "link_part_part", action: "insert", record: {part_parent: this.data.p_ref, part_child: p.p_ref}}) ;
            }.bind(this)) ;

            this.view.longTask(function(done){
                this.api.api.transactionalChanges(changes, function(err){
                    if(err){ return done(err) ;}
                    this.refresh() ;
                    done() ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


module.exports = partController ;